var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPersonGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 21,
    viewBox: "0 0 19 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4623 0.752344C6.56732 0.752344 4.2123 3.10736 4.2123 6.00234C4.2123 8.89733 6.56732 11.2523 9.4623 11.2523C12.3573 11.2523 14.7123 8.89733 14.7123 6.00234C14.7123 3.10736 12.3573 0.752344 9.4623 0.752344ZM9.4623 9.81901C7.35793 9.81901 5.64564 8.10672 5.64564 6.00234C5.64564 3.89797 7.35793 2.18568 9.4623 2.18568C11.5667 2.18568 13.279 3.89797 13.279 6.00234C13.279 8.10672 11.5667 9.81901 9.4623 9.81901Z",
    fill: "#505050",
    stroke: "#25368D",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9151 14.3276C14.4911 12.8817 12.6018 12.0844 10.5962 12.0844H8.32956C6.32406 12.0844 4.43469 12.8817 3.01064 14.3276C1.59372 15.7663 0.812891 17.6662 0.812891 19.6766C0.812891 20.0724 1.13376 20.3933 1.52956 20.3933H17.3962C17.792 20.3933 18.1129 20.0724 18.1129 19.6766C18.1129 17.6662 17.3321 15.7663 15.9151 14.3276ZM16.6386 18.9599H2.28716C2.63892 15.8989 5.21616 13.5177 8.32956 13.5177H10.5962C13.7096 13.5177 16.2869 15.8989 16.6386 18.9599Z",
    fill: "#505050",
    stroke: "#25368D",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPersonGray);
export default __webpack_public_path__ + "static/media/icon-person-gray.1a5e5fbc3c65396b6e28a2ba8df9ec95.svg";
export { ForwardRef as ReactComponent };